// extracted by mini-css-extract-plugin
module.exports = {"tabs_wrapper":"styles_tabs_wrapper__u8k8H","list_scroll":"styles_list_scroll__dvEUC"};